import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FaWhatsapp, 
  FaFacebook, 
  FaInstagram, 
  FaLinkedin,
  FaGraduationCap,
  FaInfoCircle,
  FaGamepad,
  FaBars,
  FaTimes,
  FaHome,
  FaClipboardList,
  FaMapMarkedAlt
} from 'react-icons/fa';
import './Navbar.css';
import logo from "../Assets/Logo.webp";
import miniLogo from "../Assets/Logo.webp";
import PopupForm from '../Form/PopupForm';

function Navbar() {
  const [expanded, setExpanded] = useState(false);
  const [courseDropdownOpen, setCourseDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  const location = useLocation();

  const handleOpenForm = () => setShowForm(true);
  const handleCloseForm = () => setShowForm(false);

  // Track window resize for mobile detection
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleMouseEnter = () => {
    if (!isMobile) {
      setExpanded(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      setExpanded(false);
      setCourseDropdownOpen(false);
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    if (!mobileMenuOpen) {
      setExpanded(true);
    }
  };

  const toggleCourseDropdown = () => {
    setCourseDropdownOpen(!courseDropdownOpen);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const isCourseActive = () => {
    const coursePaths = ['/beginners', '/intermediate', '/advanced'];
    return coursePaths.includes(location.pathname);
  };

  // Handle mobile menu link click
  const handleMobileLinkClick = () => {
    if (isMobile) {
      setMobileMenuOpen(false);
    }
  };

  return (
    <>
      <div className="top-logo-container">
        <img
          className="total_logo"
          src={logo}
          alt="logo"
          width={600}
          height={198}
          onClick={() => {
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }}
        />
      </div>

      {/* Mobile Menu Toggle Button */}
      <div className="mobile-menu-toggle">
        <button onClick={toggleMobileMenu}>
          {mobileMenuOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
        </button>
      </div>

      <div 
        className={`collapsible-sidebar ${expanded ? 'expanded' : 'collapsed'} ${mobileMenuOpen ? 'mobile-open' : ''}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="sidebar-content">
          
          {/* Logo */}
          <div className="sidebar-logo">
            <Link to="/" className="logo-container" onClick={handleMobileLinkClick}>
              <img
                src={expanded ? logo : miniLogo}
                alt="Boldly English Logo"
                width={600}
                height={198}
                className={`logo-img ${expanded ? 'full-logo' : 'mini-logo'}`}
              />
            </Link>
          </div>

          {/* Navigation */}
          <nav className="sidebar-nav">
            <ul className="sidebar-nav-links">
              <li className="sidebar-nav-item">
                <Link
                  to="/"
                  className={`sidebar-nav-link ${isActive('/') ? 'active' : ''}`}
                  onClick={handleMobileLinkClick}
                >
                  <span className="icon-container">
                    <FaHome size={expanded ? 18 : 22} />
                  </span>
                  <span className={`nav-text ${expanded ? 'visible' : ''}`}>Hi</span>
                </Link>
              </li>

              {/* Course Link/Dropdown */}
              <li className={`sidebar-nav-item ${isCourseActive() ? 'active' : ''}`}>
                <div 
                  className={`sidebar-nav-link dropdown-trigger ${isCourseActive() ? 'active' : ''}`}
                  onClick={toggleCourseDropdown}
                >
                  <span className="icon-container">
                    <FaGraduationCap size={expanded ? 18 : 22} />
                  </span>
                  <span className={`nav-text ${expanded ? 'visible' : ''}`}>Let's Start</span>
                  {expanded && (
                    <span className="dropdown-arrow">
                      <i className={`arrow ${courseDropdownOpen ? 'up' : 'down'}`}></i>
                    </span>
                  )}
                </div>
                
                {expanded && (
                  <ul className={`sidebar-dropdown-menu ${courseDropdownOpen ? 'open' : ''}`}>
                    <li>
                      <Link 
                        to="/beginners"
                        className={`sidebar-dropdown-link ${isActive('/beginners') ? 'active' : ''}`}
                        onClick={handleMobileLinkClick}
                      >
                        Beginner
                      </Link>
                    </li>
                    <li>
                      <Link 
                        to="/intermediate"
                        className={`sidebar-dropdown-link ${isActive('/intermediate') ? 'active' : ''}`}
                        onClick={handleMobileLinkClick}
                      >
                        Intermediate
                      </Link>
                    </li>
                    <li>
                      <Link 
                        to="/advanced"
                        className={`sidebar-dropdown-link ${isActive('/advanced') ? 'active' : ''}`}
                        onClick={handleMobileLinkClick}
                      >
                        Advanced
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              <li className="sidebar-nav-item">
                <Link
                  to="/about"
                  className={`sidebar-nav-link ${isActive('/about') ? 'active' : ''}`}
                  onClick={handleMobileLinkClick}
                >
                  <span className="icon-container">
                    <FaInfoCircle size={expanded ? 18 : 22} />
                  </span>
                  <span className={`nav-text ${expanded ? 'visible' : ''}`}>Know Us</span>
                </Link>
              </li>

              <li className="sidebar-nav-item">
                <Link
                  to="/journey"
                  className={`sidebar-nav-link ${isActive('/journey') ? 'active' : ''}`}
                  onClick={handleMobileLinkClick}
                >
                  <span className="icon-container">
                    <FaMapMarkedAlt size={expanded ? 18 : 22} />
                  </span>
                  <span className={`nav-text ${expanded ? 'visible' : ''}`}>Our Journey</span>
                </Link>
              </li>

              <li className="sidebar-nav-item">
                <Link
                  to="/levelup"
                  className={`sidebar-nav-link ${isActive('/levelup') ? 'active' : ''}`}
                  onClick={handleMobileLinkClick}
                >
                  <span className="icon-container">
                    <FaGamepad size={expanded ? 18 : 22} />
                  </span>
                  <span className={`nav-text ${expanded ? 'visible' : ''}`}>Let's play</span>
                </Link>
              </li>

              <li className="sidebar-nav-item">
                <div
                  className="sidebar-nav-link"
                  onClick={handleOpenForm}
                >
                  <span className="icon-container">
                    <FaClipboardList size={expanded ? 18 : 22} />
                  </span>
                  <span className={`nav-text ${expanded ? 'visible' : ''}`}>Take Assessment</span>
                </div>
              </li>
            </ul>
          </nav>

          {/* Social Media Icons */}
          <div className="sidebar-social">
            {expanded && (
              <>
                <a href="https://www.instagram.com/boldlyenglishindia/" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <FaInstagram size={18} />
                </a>
                <a href="https://www.facebook.com/people/Boldy-English/pfbid024Hapj4y2wfirJomZajJF9pzhZBMCasH882SodT7NvUbadiRiswzKnPgRgdqaCtvEl/" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <FaFacebook size={18} />
                </a>
                <a href="https://www.linkedin.com/in/boldly-english-450a8934a" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <FaLinkedin size={18} />
                </a>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Overlay for mobile menu */}
      {mobileMenuOpen && isMobile && (
        <div className="mobile-menu-overlay" onClick={toggleMobileMenu}></div>
      )}
      
      <div>
        <a
          href="https://wa.me/917598484799?text=Hello%20Mam"
          target="_blank"
          rel="noopener noreferrer"
          className="free-trail-all-but"
        >
          <FaWhatsapp size={20} style={{ marginRight: '8px' }} />
          Free Trial
        </a>
      </div>
      
      <PopupForm isOpen={showForm} onClose={handleCloseForm} />
    </>
  );
}

export default Navbar;